import React, { FC, useEffect, useState } from "react";
import ArgeLogo from "../../assets/ArgeLogo.png";
import Hamburger from "../../assets/Hamburger.svg";
import RhBLogo from "../../assets/RhB_Logo.jpg";
import { useTranslation } from "react-i18next";
import FilterMenu from "./LineFilter";
import Campaign from "./YearFilter";
import useAppStore from "../Store/AppStore";
import "./Navigation.scss";

import { Link } from "react-router-dom";
import { setKeyVaultSecret } from "../../service/apiService";

const Navigation: FC = ({}) => {
    const { t } = useTranslation();
    const pathname = window.location.pathname;

    const hasYearFilters = useAppStore((state) => state.yearFilterValues.length > 0);
    const hasLineFilters = useAppStore((state) => state.lineFilterValues.length > 0);
    const environment = useAppStore((state) => state.environment)
    const featureFlags = useAppStore((state) => state.featureFlags)

    const errorReportUrl = useAppStore((state) => state.errorReportUrl);
    const setErrorReportUrl = useAppStore((state) => state.setErrorReportUrl);

    const faultReportFeature = featureFlags?.find(
        (feature) => feature.description === "FaultReportBtn"
    );

    const [activeLink, setActiveLink] = useState("/karte");

    const modalPopupIsOpen = useAppStore((state) => state.modalPopupIsOpen);
    const setModalPopupIsOpen = useAppStore((state) => state.setModalPopupIsOpen);
    const setCurrentPopup = useAppStore((state) => state.setCurrentPopup);

    const handlePopupOpen = () => {
        setModalPopupIsOpen(!modalPopupIsOpen);
        setCurrentPopup("menu");
    };

    const handleLinkClick = (link: string) => {
        setActiveLink(link);
    };

    useEffect(() => {
        setActiveLink(pathname);
    }, [pathname]);

    useEffect(() => {
            if (faultReportFeature?.active === true) {
                const initializeErrorReport = async () => {
                    const result = await setKeyVaultSecret("ERRORREPORTURL");
                    if (typeof result !== "string") {
                        throw new Error("Expected ERRORREPORTURL to be a string");
                    }
                    setErrorReportUrl(result);
                }
                initializeErrorReport();
            }
        },
        [faultReportFeature, setErrorReportUrl]);

    return (
        <header>
            <nav
                className="fixed top-0 right-0 left-0 z-50 flex justify-between w-full h-[64px] bg-white drop-shadow-md">
                <div className="flex justify-between w-[95%] mr-[40px]">
                    <div className="different-pages flex items-center w-3/5 max-w-xl h-full">
                        <div className="project-name flex items-center xl:w-2/6 h-full">
                            <div className="project-icon">
                                <a
                                    href={environment === "Showcase" ? "https://showcase.fahrwegdiagnose.ch/karte" : "https://dashboard.fahrwegdiagnose.ch/karte"}
                                    target="_blank"
                                >
                                    <img
                                        src={ArgeLogo}
                                        className="h-[25px] w-[25px] min-w-[25px] cursor-pointer"
                                    />
                                </a>
                            </div>
                            <div className="project-name-fwd shrink-0 min-w-[180px] ml-[14px]">
                                <p className="text-sm font-black">{t("fahrweg")}</p>
                                <p className="text-xs font-medium text-gray450">
                                    {t("dashboard")}
                                </p>
                            </div>
                        </div>
                        <div className="nav-links flex xl:w-3/6 h-full">
                            <Link
                                to="/karte"
                                className={`menu nav-link w-[140px] shrink-0 flex items-center justify-center text-center text-gray550 ${activeLink == "/karte" ? "bg-sersa text-white" : "bg-white"
                                }`}
                                onClick={() => handleLinkClick("/karte")}
                            >
                                {t("karte")}
                            </Link>
                            <Link
                                to="/summary"
                                className={`menu nav-link w-[140px] shrink-0 flex items-center justify-center text-center text-gray550 ${activeLink == "/summary" ? "bg-sersa text-white" : "bg-white"
                                }`}
                                onClick={() => handleLinkClick("/summary")}
                            >
                                {t("summary")}
                            </Link>
                            <Link
                                to="/hub"
                                className={`menu nav-link w-[140px] shrink-0  flex items-center justify-center text-center text-gray550 ${activeLink == "/hub" ? "bg-sersa text-white" : "bg-white"
                                }`}
                                onClick={() => handleLinkClick("/hub")}
                            >
                                {t("hub")}
                            </Link>
                            {faultReportFeature?.active && (
                                <Link
                                    to={errorReportUrl}
                                    target="_blank"
                                    className={`menu nav-link w-[140px] shrink-0 flex items-center justify-center text-center text-gray550 ${activeLink === errorReportUrl ? "bg-sersa text-white" : "bg-white"
                                    }`}
                                >
                                    {t("faultReport")}
                                </Link>
                            )}
                        </div>
                    </div>
                    {/* RhB powered by logo */}
                    {environment === "Showcase" && (
                        <div className="flex ml-10 mr-10 items-center">
                            <h1 className="text-sm mr-4">powered by</h1>
                            <a href="https://www.rhb.ch/" target="_blank">
                                <img
                                    src={RhBLogo}
                                    className="h-10 cursor-pointer"
                                    alt={"RhB"}
                                />
                            </a>
                        </div>
                    )}
                    <div className="dropdown-selection flex xl:w-1/3 xl:max-w-sm">
                        <div className="line xl:w-1/2 h-full">
                            {hasLineFilters && <FilterMenu/>}
                        </div>
                        <div className="year xl:w-1/2 h-full">
                            {hasYearFilters && <Campaign/>}
                        </div>
                    </div>
                </div>
                <ul className="hamburger-button-wrapper">
                    <li
                        className="button-skew flex justify-center items-center h-full bg-blue cursor-pointer"
                        onClick={handlePopupOpen}
                    >
                        <a href="#" className="px-[10px]">
                            <img src={Hamburger} className="hamburger-icon"/>
                        </a>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Navigation;
